<template>
    <el-checkbox
        v-model="currentValue"
        v-if="permissionsShow"
        :checked="checked"
        :disabled="disabled"
        :border="border"
        :name="$t(name)"
        :true-label="trueLabel"
        :false-label="falseLabel"
        :indeterminate="indeterminate"
        @change="_change"
    >
        <slot></slot>
    </el-checkbox>
</template>
<script>
export default {
    props: {
        /* 默认值 */
        value: {},
        /* 是否禁用 */
        disabled: Boolean,
        /* 是否勾选 */
        checked: Boolean,
        /* 是否启用边框 */
        border: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 选中时的值 */
        trueLabel: Number,
        /* 没有选中时的值 */
        falseLabel: Number,
        /* 原生 name 属性 */
        name: String,
        /* 设置 indeterminate 状态，只负责样式控制 */
        indeterminate: Boolean,
        /* 所有权限信息 */
        permissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 角色信息 */
        roles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 权限之一 */
        oneOfPermissions: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    data() {
        return {
            /* 是否满足显示权限 */
            permissionsShow: true
        };
    },
    created() {
        /* 权限数据处理 */
        if (this.permissions.length > 0 || this.oneOfPermissions.length > 0 || this.roles.length > 0) {
            this.permissionsShow = this.dealPermissions(this.permissions, this.roles, this.oneOfPermissions);
        }
    },
    computed: {
        currentValue: function() {
            /* 若设定特殊值，value为空时自动设置为未选中状态 */
            if (this.$util.isEmpty(this.value) && !this.$util.isEmpty(this.falseLabel)) {
                this.$emit('input', this.falseLabel);
                return this.falseLabel;
            } else {
                return this.value;
            }
        }
    },
    watch: {
        /* 监听禁用值的编号实时响应 */
        disabled(newVue) {
            this.disabled = newVue;
        }
    },
    methods: {
        /* 当绑定值变化时触发的事件，调用父组件方法 */
        _change(value) {
            this.$emit('change', value);
            this.$emit('input', value);
        },
        /* 获取当前check状态值，提供父组件调用 */
        getValue() {
            return this.value;
        }
    }
};
</script>
